import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-vkyc',
  templateUrl: './vkyc.component.html',
  styleUrl: './vkyc.component.scss'
})
export class VkycComponent {

  approvedAmount: string = null;
  showVKYC: boolean = false;
  constructor(private spinner: NgxSpinnerService, private finzyService: FinzyService, private route: ActivatedRoute, private router: Router) { }
  ngOnInit(): void {
    this.spinner.hide();

    this.approvedAmount = MemoryStorageService.getItem("finalApprovedAmount");

    this.route.queryParamMap.subscribe(async params => {
      const status = params.get('status');
      const transId = params.get('transactionid');

      if (status === 'true' && transId) {
        this.spinner.show();
        try {
          var res = await lastValueFrom(this.finzyService.UpdateVKYC({ status: status, transactionId: transId }));
          if (res['data'] === "success") {
            this.spinner.hide();
            return this.router.navigateByUrl('/assist-journey/f/current-address');
          }
        } catch (err) {
          if (err?.status === 401) {
            this.spinner.hide();
            this.router.navigateByUrl('/assist-journey/session-expired');
          }

          if (err.status === 0) {
            this.spinner.hide();
            swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
            return;
          }
        }
      }
    });
  }

  async startVideoKyc() {
    this.spinner.show();
    try {
      var res = await lastValueFrom(this.finzyService.InitiateVKYC());
      if (res['data']) {
        this.spinner.hide();
        window.location.href = res['data'];
      }
      else {
        this.spinner.hide();
        swal.fire('Error', 'Error initiating Video KYC. Please try again later.');
      }
    } catch (err) {
      if (err.status === 0) {
        swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
        return;
      }

      if (err?.status === 401) {
        this.spinner.hide();
        this.router.navigateByUrl('/assist-journey/session-expired');
      }
    }
    this.spinner.hide();
  }

  proceedProcess() {
    this.showVKYC = true;
  }
}
